/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { Embed } from "./data-contracts";

/**
 * No description
 * @tags space-embeds
 * @name GetEmbedByUrlInSpace
 * @summary Resolve a URL to an embed in a given space
 * @request GET:/spaces/{spaceId}/embed
 * @secure
 */

// @ts-ignore
export const getEmbedByUrlInSpace: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** URL to resolve */
    url: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Embed;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/embed",
  method: "get",
  streaming: false,
  tags: ["space-embeds"],
  criticalityLevel: "low",
  deprecated: false,
};
